document.addEventListener("DOMContentLoaded", () => {
  const productList = document.querySelector(".boost-sd__filter-product-list.boost-sd__filter-product-list--ready"); //Boost #233340
  
  if (!productList) {
      console.error("Product list not found!");
  } else {
      const config = { childList: true };
  
      const callback = (mutationList, observer) => {
          for (const mutation of mutationList) {
              if (mutation.target === productList) {
                // Please add your wishlist callback here to rerender wishlist again
                let intervalWishlist = setInterval(disableRedirectWhenClickWishlist, 500);
                function disableRedirectWhenClickWishlist() {
                  var iconWishlists = document.querySelectorAll('.boost-sd__product-item wishlist-button-collection');
                  if(iconWishlists.length > 0){
                    clearInterval(intervalWishlist);
                    iconWishlists.forEach(function(element) {
                      element.addEventListener('click', function(e) {
                        e.stopImmediatePropagation();
                      });
                    });
                  }
                }
              }
          }
      };
  
      const observer = new MutationObserver(callback);
  
      try {
          observer.observe(productList, config);
      } catch (error) {
          console.error("Observer failed");
      }
  }
});
